<template>
<div class='risk-score-legend'>
  <div class='risk-score-legend__letter' :style="{'color': color}">{{letter}}</div>
  <div class='risk-score-legend__text' :style="{'color': color}">{{text}}</div>
</div>
</template>
<script>
export default {
  name: 'RiskScoreLegend',
  props: {
    letter: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang='scss'>
@import '~@/assets/styles/design-system';

.risk-score-legend {
  display: flex;
  flex-direction: row;
  min-width: 88px;

  &__letter {
    font-family: $font-family-bold;
    font-size: $font-size-md;
    text-transform: capitalize;
    margin-right: $space-2;
  }

  &__text {
    font-family: $font-family-regular;
    font-size: $font-size-md;
    margin-right: $space-1;
  }
}
</style>
